import { render, staticRenderFns } from "./UnpaidSpousalSupport.vue?vue&type=template&id=7c2f3c5a"
import script from "./UnpaidSpousalSupport.vue?vue&type=script&lang=ts"
export * from "./UnpaidSpousalSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports